var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import TextInput from '../TextInput';
var StyledNumberInput = styled(TextInput).attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var NumericStepper = function (props) {
    var attributes = props.attributes;
    var floatPrecission = attributes.floatPrecission, minRange = attributes.minRange, maxRange = attributes.maxRange;
    return (React.createElement(StyledNumberInput, __assign({}, props, { type: "number", step: floatPrecission, min: minRange, max: maxRange })));
};
export default NumericStepper;
var templateObject_1;
//# sourceMappingURL=index.js.map